var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGhst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.753 12.358h2.037v1.358h-4.753v-1.358h1.358V11h1.358v1.358zm-2.716 3.395H16.68v-2.037h1.357v2.037zm3.395 1.358h-3.395v-1.357h3.395v1.358zm0 2.038v-2.037h1.358v2.038h-1.358zm0 0v1.358h-.679v1.358h-1.358v-1.358H16.68v-1.358h4.752zM9.21 12.358h1.296v3.395h3.395l.063-3.395h1.296v8.148H13.9v-3.395h-3.394v3.396H9.21v-8.148zm-1.42 0H2.358v1.358H1v5.432h1.358v1.358h4.074v-1.358H7.79v-3.395H3.716v1.358h2.716v2.038H2.358v-5.432H7.79v-1.358zm19.136 8.21h1.358v-6.852H31v-1.358h-6.79v1.358h2.716v6.852z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGhst);
export default __webpack_public_path__ + "static/media/GHST.c881e0151d89caf5cdb03260ebe6d0f8.svg";
export { ForwardRef as ReactComponent };